import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { ProductTypes, TvProduct } from '@dch/products-business-logic';
import { OnDestroyHookDirective } from 'src/app/shared/hooks';
import { getPiiServiceId } from 'src/app/shared/pii/pii.utils';
import { GetProductDetails } from 'src/app/store/actions/product-details.actions';
import {
  ApplicationState,
  getProductDetailsTechnicalError,
  getSelectedProductDetails,
} from 'src/app/store/reducers';
import { getUsageProductFrom } from 'src/app/shared/usage/util';
import { Product as UsageProduct } from '@proximus/usage-business-logic';

declare let inception;

@Component({
  selector: 'mprd-tv-usage-pxsplus',
  templateUrl: './tv-usage-pxsplus.component.html',
})
export class TvUsagePxsplusComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  selectedProduct: TvProduct;
  hasError: boolean;
  usageProduct: UsageProduct;
  fragmentId: string;
  remainingDaysLabel: string;

  constructor(
    private store: Store<ApplicationState>,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit(): void {
    this.loadInternetDetails();
  }

  private loadInternetDetails() {
    const serviceId = getPiiServiceId();
    if (serviceId) {
      this.addSubscription(
        this.store.select(getSelectedProductDetails).subscribe((value) => {
          if (value && value.tvProductDetails) {
            this.selectedProduct = value.tvProductDetails;
            this.usageProduct = getUsageProductFrom(this.selectedProduct);
          }
        }),
      );
      this.addSubscription(
        this.route.params.subscribe((params) => {
          this.store.dispatch(
            new GetProductDetails({
              productType: ProductTypes.TV.toString(),
              serviceId,
            }),
          );
        }),
      );
      this.addSubscription(
        this.store
          .select(getProductDetailsTechnicalError)
          .subscribe((value) => {
            this.hasError = value !== null;
          }),
      );
    }
  }
  usageInitializedWith(remainingDaysLabel: string) {
    if (remainingDaysLabel) {
      this.remainingDaysLabel = remainingDaysLabel;
      this.initMasonry();
    }
  }
  initMasonry() {
    setTimeout(() => {
      inception.masonry('[data-masonry-container]');
    });
  }
}
